interface EmptyStateProps {
  columns: number;
  message?: string;
}

export function EmptyState({ columns, message = "No data" }: EmptyStateProps) {
  return (
    <tr>
      <td
        colSpan={columns}
        className="px-3 py-8 text-center text-sm text-fg-faint"
      >
        {message}
      </td>
    </tr>
  );
}
